import styled from 'styled-components'
import { hFlex } from '../../../../../../../../../../Styles/style-helpers'
import { H6, S05 } from '../../../../../../../../../../Styles/typography'

export const ChapterEl = styled.div`
  display: block;
  margin-top: 2.5em;
  padding: 0 1em;

  &:last-of-type {
    margin-bottom: 5em;
  }

  .title {
    ${hFlex};
    align-items: flex-start;
    margin-bottom: 1em;

    & > svg {
      margin-top: 0.9em;
      font-size: 1.5em;
    }

    & > div {
      margin-left: 1em;
      width: 100%;

      & > ${S05} {
        margin-bottom: 0.5em;
        text-transform: uppercase;
        letter-spacing: 0.075em;
        opacity: 0.3;
      }

      & > ${H6} {
        line-height: 1.3;
      }
    }
  }

  .lessons {
    width: 100%;
    padding-left: 2.75em;
  }
`
